<template>
  <div v-if="favorites.length > 0" class="favorites-bar">
    <ul>
      <li v-for="favorite in favorites" :key="favorite.id" class="favorite-item">
        <!-- With URL -->
        <div class="tooltip-wrapper">
          <RouterLink
            v-if="favorite.url"
            :to="favorite.url"
            class="favorite-link"
          >
            <i :class="favorite.icon"></i>
            <span class="favorite-label">{{ truncatedLabel(favorite.label) }}</span>
          </RouterLink>

          <!-- Without URL -->
          <span v-else class="favorite-link">
            <i :class="favorite.icon"></i>
            <span class="favorite-label">{{ truncatedLabel(favorite.label) }} (No Link)</span>
          </span>

          <!-- Custom tooltip content -->
          <span class="tooltip">{{ favorite.label }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { useStore } from 'vuex';
import { computed } from 'vue';

// Access Vuex store
const store = useStore();

// Get the favorites from Vuex store
const favorites = computed(() => store.getters['auth/favorites']);

// Function to truncate labels for longer text
const truncatedLabel = (label) => {
    if (label.length > 20) {
        return label.substring(0, 15) + '...';  // Truncate to 15 chars and add ellipsis
    }
    return label;
};
</script>

<style scoped lang="scss">
.favorites-bar {
  overflow: visible !important; // <-- Add this
  position: relative; // <-- Ensure it has a position context
  display: flex;
  flex-wrap: nowrap; /* Ensures the items don't wrap to the next line */
  overflow-x: auto;  /* Adds horizontal scrolling if the items overflow */
  background: linear-gradient(90deg, #24d8c5 0%, #00d38c 100%);
  padding: 10px;
  box-shadow: 0 2px 5px rgba(1, 47, 24, 0.478);
  justify-content: flex-start;
  top: 71px;

  display: flex;
  margin: 0;
  padding: 10px;
  overflow-x: auto;
  height: 40px;

  ul {
    display: flex;  /* Ensures the list items are laid out in a horizontal line */
    padding: 0;
    margin: 0;
    list-style-type: none;  /* Removes the default list bullets */
  }

  .favorite-item {
    margin-right: 15px;  /* Adds space between each favorite item */
  }

  .favorite-link {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #fbfbfb;
    font-size: 12px;
  }

  .favorite-link:hover {
    text-decoration: underline;
  }

  .favorite-item i {
    margin-right: 8px;
  }

  .favorite-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
    display: inline-block;
  }
}

.tooltip-wrapper {
  position: relative;
  display: inline-block;

  .tooltip {
    visibility: hidden;
    background-color: #333;
    color: #fff;
    text-align: center;
    padding: 6px 8px;
    border-radius: 4px;
    position: absolute;
    z-index: 99999999;
    top: 125%; /* Now appears below the item */
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    font-size: 12px;
    opacity: 0;
    transition: opacity 0.3s ease;

    /* Tooltip arrow (points UP now) */
    &::after {
      content: '';
      position: absolute;
      bottom: 100%; /* Arrow sits at the top of the tooltip */
      left: 50%;
      transform: translateX(-50%);
      border-width: 5px;
      border-style: solid;
      border-color: transparent transparent #333 transparent;
    }
  }

  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }
}


</style>
